/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function FilterBasicResourceListPinsFromJSON(json) {
    return FilterBasicResourceListPinsFromJSONTyped(json, false);
}
export function FilterBasicResourceListPinsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        counts: !exists(json, 'counts') ? undefined : json['counts'],
        id: !exists(json, 'id') ? undefined : json['id'],
        text: !exists(json, 'text') ? undefined : json['text']
    };
}
export function FilterBasicResourceListPinsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        counts: value.counts,
        id: value.id,
        text: value.text
    };
}
